export default require('../../client/death/certificate/CertificatePage')
  .default;
